export const SHOW_SEARCH_INPUT_LABEL = {
  english: { submitlabel: 'Submit', close: 'Clear', search: 'search' },
  spanish: { submitlabel: 'Entregar', close: 'Cerrar', search: 'búsqueda' },
  hindi: { submitlabel: 'प्रस्तुत', close: 'बंद करे', search: 'तलाशी' }
};

export const AUTOCOMPLETE = {
  on: 'on',
  off: 'off'
};

export const ERRORMESSAGE = {
  errorEnglish: 'Please Insert any value',
  errorHindi: 'कृपया कोई मूल्य डालें',
  errorSpanish: 'Por favor, inserte cualquier valor'
};